module.exports = __webpack_public_path__ + "img/logo_f.f527e31f.png";